import { useParams } from "react-router-dom";
import { SurveyUnpublished } from "features/scorable/Survey";
import { useAppDispatch } from "app/hooks";
import { useEffect } from "react";
import FormType from "enums/FormType";
import { loadScorable } from "features/scorable/scorableSlice";
import { getCurrentRegion } from "util/envUtils";
import { FormLocaleProvider, useLocale } from "features/i18n/useLocale";

export function getSurveyCodeUrl(code: string | undefined) {
    return `https://apps.${getCurrentRegion()}/quality-forms/#/surveycodes/${code}`;
}
export function SurveyCode() {
    const { code } = useParams();
    const surveyUrl = getSurveyCodeUrl(code);

    // add lang attribute for accessibility
    // this gets the <html> element
    document.documentElement.lang = useLocale();
    // add role main since survey code is not embedded in web-directory
    document.querySelector(".quality-forms-app")?.setAttribute("role", "main");

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (surveyUrl) {
            dispatch(
                loadScorable({
                    formType: FormType.SURVEY,
                    surveyUrl,
                })
            );
        }
    }, [dispatch, surveyUrl]);

    return (
        <FormLocaleProvider>
            <SurveyUnpublished />
        </FormLocaleProvider>
    );
}
